import React, { Component } from 'react';
import { ThemeProvider as Provider } from 'styled-components';

import * as themes from '../../index';

// ///////////////////////////////////////////////////////////////////
// ///////////////////////////////////////////////////////////////////

export default class ThemeProvider extends Component {
    static defaultProps = {
        theme: 'efteling',
        variant: 'default',
    };

    // ///////////////////////////////////////////////////////
    get theme() {
        if (themes[this.props.theme]) {
            return themes[this.props.theme](this.props.variant);
        }
        return themes.efteling(this.props.variant || 'default');
    }

    render() {
        return <Provider theme={this.theme}>{this.props.children}</Provider>;
    }
}
